export enum SignupCouponParamsSettingsKeys {
  SignupCouponId = 'signupCouponId',
  SignupPlan = 'signupPlan',
  SignupPeriod = 'signupPeriod',
  SignupPromoEndDate = 'signupPromoEndDate',
}
